import { render, staticRenderFns } from "./MusicTable.vue?vue&type=template&id=700b00c6"
import script from "./MusicTable.vue?vue&type=script&lang=js"
export * from "./MusicTable.vue?vue&type=script&lang=js"
import style0 from "./MusicTable.vue?vue&type=style&index=0&id=700b00c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports